document.addEventListener("DOMContentLoaded", async function () {
    const API_BASE_URL = "https://resurs.dahlquist.se";

    const calculator = document.getElementById('financing-calculator');
    const toggleBtn = document.getElementById('calculator-toggle-btn');
    const allPeriodButtons = document.querySelectorAll('.period-btn');
    const inputDown = document.getElementById('down-value');
    const inputTotalCustom = document.getElementById('custom-total');
    const maxPriceCalc = inputTotalCustom.max;
    const productPrice = document.getElementById('product-price')?.value || maxPriceCalc;
    const inputLoan = document.getElementById('loan-amount');
    const rangeDown = document.getElementById('down');
    const rangeLoan = document.getElementById('loan-range');
    const exampleToggle = document.getElementById('representative-example-toggle');
    const exampleContent = document.getElementById('representative-example-content');
    const calcBlock = document.getElementById('financing-calculator').querySelector('.right-column');

    let month = 24;
    let costList = {};

    async function fetchRates() {
        const amount = parseInt(inputLoan.value);
        let marketUrl = Shopify?.routes?.root ?? '';
        if (marketUrl.endsWith("/")) {
            marketUrl = marketUrl.slice(0, -1);
        }
        try {
            const res = await fetch(`${API_BASE_URL}/api/resursbank/price_signage?shop=${Shopify.shop}${marketUrl}&amount=${Math.round(amount)}`);
            const response = await res.json();
            if (response.success && response.data && response.data.length) {
                response.data.forEach(item => {
                    costList[item.durationMonths] = item;
                });
            }
        } catch (err) {
            console.error("ERROR API Resurs:", err);
        }
    }

    function calculate() {
        const down = parseInt(inputDown.value) || 0;
        const loan = parseInt(inputLoan.value) || 0;

        updateUI({
            down: down,
            loan: loan,
            months: month,
            nominalRate: costList?.[month]?.interest / 100,
            monthly: costList?.[month]?.monthlyCost,
            adminTotal: costList?.[month]?.administrationFee * month,
            effective: costList?.[month]?.effectiveInterest / 100
        });

        // updateNotes(down);

        calcBlock.classList.remove('loading');
    }

    function updateUI(data) {
        const formatCurrency = (num) => num.toLocaleString('sv-SE', { maximumFractionDigits: 0 });
        const formatPercent = (rate) => `${(rate * 100).toFixed(2)}%`;

        document.getElementById('r-down').textContent = `${formatCurrency(data.down)} kr`;
        document.getElementById('r-loan').textContent = `${formatCurrency(data.loan)} kr`;
        document.getElementById('r-period').textContent = `${data.months} mån`;

        const nominalRateText = formatPercent(data.nominalRate);
        document.getElementById('r-interest').textContent = nominalRateText;
        document.getElementById('summary-interest-rate').textContent = nominalRateText;

        const finalMonthly = data.monthly > 0 ? `${formatCurrency(Math.ceil(data.monthly))} kr/mån*` : "-";
        document.getElementById('r-monthly').textContent = finalMonthly;
        document.getElementById('summary-monthly-cost').textContent = finalMonthly;

        document.getElementById('r-admin-total').textContent = `${formatCurrency(data.adminTotal)} kr`;
        document.getElementById('r-effective').textContent = data.effective > 0 ? formatPercent(data.effective) : "-";
    }

    function updateNotes(kontantinsats) {
        if (!kontantinsats || kontantinsats <= 0) {
            return;
        }

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                note: `Kontantinsats: ${kontantinsats} kr`
            })
        })
        .then(response => response.json())
        .then(cart => {
            console.log('Cart updated');
        })
        .catch(error => {
            console.error('Error updating cart:', error);
        });
    }

    allPeriodButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
            month = parseInt(e.currentTarget.dataset.value, 10);
            allPeriodButtons.forEach(b => b.classList.remove('active'));
            document.querySelectorAll(`.period-btn[data-value="${month}"]`).forEach(b => b.classList.add('active'));
            calculate();
        });
    });

    function syncInputs(input) {
        const total = parseInt(inputTotalCustom.value) || 0;
        let down = 0, loan = 0;

        if (input.id.includes('down')) {
            down = parseInt(input.value) || 0;
            loan = Math.max(0, total - down);
        } else if (input.id.includes('loan')) {
            loan = parseInt(input.value) || 0;
            down = Math.max(0, total - loan);
        }

        inputDown.value = rangeDown.value = down;
        inputLoan.value = rangeLoan.value = loan;
    }

    [rangeDown, rangeLoan, inputDown, inputLoan].forEach(input => {
        input.addEventListener('input', () => {
            const value = Math.min(input.value, rangeLoan.max);
            inputDown.value = inputLoan.value = inputLoan.value = rangeLoan.value = value;
            syncInputs(input);
        });
        input.addEventListener('change', async () => {
            calcBlock.classList.add('loading');
            await fetchRates();
            calculate();
        });
    });

    inputTotalCustom.addEventListener('change', () => {
        let total = parseInt(inputTotalCustom.value) || 0;

        total = Math.min(Math.max(total, 10), maxPriceCalc);
        inputTotalCustom.value = total;

        inputDown.value = 0;
        rangeDown.max = rangeLoan.max = inputLoan.value = total;
        syncInputs(inputLoan);
        inputLoan.dispatchEvent(new Event('change'));
    });

    toggleBtn.addEventListener('click', () => {
        const isOpen = calculator.classList.contains('calculator-open');
        calculator.classList.toggle('calculator-open');
        calculator.classList.toggle('calculator-closed', !isOpen);
        toggleBtn.querySelector('.toggle-icon').textContent = isOpen ? '+' : '-';
        toggleBtn.querySelector('.toggle-text').innerHTML = isOpen
            ? 'Öppna kalkylator <span style="font-weight: normal;">(se representativt exempel)</span>'
            : 'Dölj kalkylator';
    });

    exampleToggle.addEventListener('click', (e) => {
        e.preventDefault();
        const isVisible = exampleContent.style.display === 'block';
        exampleContent.style.display = isVisible ? 'none' : 'block';
    });

    async function initialize() {
        calcBlock.classList.add('loading');
        inputTotalCustom.value = productPrice;
        rangeDown.max = productPrice;
        rangeLoan.max = productPrice;
        syncInputs(inputLoan);
        await fetchRates();
        calculate();
    }

    initialize();
});

